import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
  selector: 'app-inpactcomponent',
  standalone: false,
  templateUrl: './inpactcomponent.component.html',
  styleUrls: ['./inpactcomponent.component.scss']
})
export class InpactcomponentComponent {
  constructor(private userInfoService:UserInfoService, protected config: OccConfig,public bannerComponent: CmsComponentData<CmsBannerComponent>,private cdr: ChangeDetectorRef ){}
  impactdata: Observable<any> = this.bannerComponent.data$; 
  screenvalue:number=999
  ngOnInit() {
   this.userInfoService.getuptake().subscribe((value:any)=>{
   this.screenvalue=value
   this.cdr.detectChanges()
   });
  }
}
